import { motion } from "framer-motion";
import { Calendar } from "lucide-react";

const Card = ({
  title,
  company,
  icon,
  startDate,
  endDate,
  accomplishments,
  isEven,
}) => {
  const cardVariants = {
    hidden: { opacity: 0, x: isEven ? -50 : 50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.6,
        ease: "easeOut",
      },
    },
  };

  return (
    <motion.div
      variants={cardVariants}
      whileHover={{ scale: 1.02 }}
      className={`bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 p-6 border-l-4 ${
        isEven ? "border-primary-500" : "border-accent-500"
      }`}
    >
      <div className="flex items-start space-x-4">
        <div className="w-16 h-16 bg-secondary-100 rounded-lg flex items-center justify-center flex-shrink-0">
          <img
            src={icon}
            alt={`${company} logo`}
            className="w-12 h-12 object-contain"
            onError={(e) => {
              e.target.style.display = "none";
              e.target.nextSibling.style.display = "block";
            }}
          />
          <div className="w-12 h-12 bg-secondary-200 rounded flex items-center justify-center hidden">
            <span className="text-secondary-600 font-bold text-lg">
              {company.charAt(0)}
            </span>
          </div>
        </div>

        <div className="flex-1 min-w-0">
          <h3 className="font-display font-semibold text-lg text-secondary-900 mb-1">
            {title}
          </h3>
          <p className="text-secondary-600 font-medium mb-2">{company}</p>

          <div className="flex items-center space-x-4 mb-4 text-sm text-secondary-500">
            <div className="flex items-center space-x-1">
              <Calendar className="w-4 h-4" />
              <span>
                {startDate} - {endDate}
              </span>
            </div>
          </div>

          <div className="space-y-2">
            {accomplishments.slice(0, 2).map((accomplishment, index) => (
              <p
                key={index}
                className="text-secondary-600 text-sm leading-relaxed"
              >
                • {accomplishment}
              </p>
            ))}
            {accomplishments.length > 2 && (
              <p className="text-primary-600 text-sm font-medium">
                +{accomplishments.length - 2} more achievements
              </p>
            )}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Card;
